import { render, staticRenderFns } from "./paciente.vue?vue&type=template&id=f4d9cd06&scoped=true&"
import script from "./paciente.vue?vue&type=script&lang=js&"
export * from "./paciente.vue?vue&type=script&lang=js&"
import style0 from "./paciente.vue?vue&type=style&index=0&id=f4d9cd06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d9cd06",
  null
  
)

export default component.exports